import JwtService from '@common/JwtService'
import { logout } from '@common/AuthHelper'
const ID_LOGOUT_TIME = 'LOG_OUT_TIME'
const ID_ACTIVE_TIME = 'LAST_ACTIVE_TIME'

export const autoLogout = () => {
  if (JwtService.getToken()) {
    if (userIsInactive()) {
      logout()
    } else {
      setLogoutTime()
    }
  }
}

export const destroyLogoutTime = () => {
  window.localStorage.removeItem(ID_LOGOUT_TIME)
}

export const lastActiveTimeInPast = () => {
  const lastActivityTime = Date.parse(
    window.localStorage.getItem(ID_ACTIVE_TIME)
  )

  let date = new Date()
  date.setHours(date.getHours() - 1)

  return lastActivityTime < date
}

export const setLastActiveTime = () => {
  const date = new Date()
  window.localStorage.setItem(ID_ACTIVE_TIME, date)
}

export const setLogoutTime = () => {
  const date = new Date()
  date.setMinutes(date.getMinutes() + 30)
  window.localStorage.setItem(ID_LOGOUT_TIME, date)
}

const userIsInactive = () => {
  return Date.parse(window.localStorage.getItem(ID_LOGOUT_TIME)) < new Date()
}

export default {
  autoLogout,
  destroyLogoutTime,
  lastActiveTimeInPast,
  setLastActiveTime,
  setLogoutTime,
}
